import { Box } from "@mui/material";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { type PartyDto, AddressType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";

type Props = {
  party: PartyDto;
};

export const MerchantPartyInfo = ({ party }: Props) => {
  const { t } = useResource();
  const { companyName, companyNumber, type, addresses } = party;
  const headquartersAddress = addresses.find(
    ({ type }) => type === AddressType.Headquarters,
  );

  return (
    <Box mb={5}>
      <ValuesBox title={t(Resources.Common.GeneralInfo)}>
        <ValueItems
          values={[
            { label: t(Resources.Common.CompanyName), value: companyName },
            {
              label: t(Resources.Common.CompanyNumber),
              value: companyNumber,
            },
            {
              label: t(Resources.Common.PartyTypeLabel),
              value: t(Resources.Form.PartyType[type]),
            },
            {
              label: t(Resources.Common.Address.Title),
              value: headquartersAddress
                ? getFormattedAddress(headquartersAddress)
                : "-",
            },
          ]}
        />
      </ValuesBox>
    </Box>
  );
};
